import React from 'react';
import PropTypes from 'prop-types';

class GifLoader extends React.Component {
  render() {
    const { overlayBackground, loading, spinnerColor } = this.props;

    const overlayBlockStyle = {
      zIndex: "99999",
      height: "100vh",
      width: "100%",
      position: "fixed",
      display: loading ? "flex" : "none", // Changed to flex for easy centering
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: overlayBackground,
      top: 0,
      left: 0
    };

    // Simple CSS Spinner Style
    const loaderStyle = {
      border: `4px solid #f3f3f3`, 
      borderTop: `4px solid ${spinnerColor}`,
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      animation: "spin 1s linear infinite",
    };

    return (
      <div style={overlayBlockStyle}>
        {/* We use a style tag here to handle the keyframe animation locally */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
        <div style={loaderStyle}></div>
      </div>
    );
  }
}

GifLoader.propTypes = {
  overlayBackground: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  spinnerColor: PropTypes.string,
};

GifLoader.defaultProps = {
  overlayBackground: "rgba(255, 255, 255, 0.8)", // Slight transparency looks better
  spinnerColor: "#3498db" // Modern blue
};

export default GifLoader;